import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';

const RicaricheTelefoniche = () => {
  const navigate = useNavigate();

  const operators = [
  {
    name: 'TIM',
    logo: "/assets/images/TIM-1771605250670.png",
    url: 'https://www.tim.it/ricarica',
    alt: 'Logo TIM - Telecom Italia Mobile'
  },
  {
    name: 'Vodafone',
    logo: "/assets/images/Vodafone-1771605459833.png",
    url: 'https://ricaricaoneclick.vodafone.it',
    alt: 'Logo Vodafone Italia'
  },
  {
    name: 'WINDTRE',
    logo: "/assets/images/Wind-1771605590004.png",
    url: 'https://www.windtre.it/ricarica-online',
    alt: 'Logo WINDTRE'
  },
  {
    name: 'Iliad',
    logo: "/assets/images/Iliad-1771605506306.png",
    url: 'https://www.iliad.it/account/ricarica',
    alt: 'Logo Iliad Italia'
  },
  {
    name: 'Fastweb',
    logo: "/assets/images/FastWeb-1771605731005.png",
    url: 'https://www.fastweb.it/myfastweb/servizi/ricarica/',
    alt: 'Logo Fastweb Mobile'
  }];


  return (
    <>
      <Helmet>
        <title>Ricariche telefoniche online | Cliccami</title>
        <meta
          name="description"
          content="Accedi rapidamente ai siti ufficiali dei principali operatori per effettuare la tua ricarica online." />
        
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => {}} />

        {/* Hero Image Section */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-4">
            <img
              src="/assets/images/ChatGPT_Image_14_feb_2026_20_28_33-1771097338622.png"
              alt="Ricarica telefonica online"
              className="w-full h-[320px] md:h-[420px] object-cover rounded-2xl shadow-lg mb-12" />
            
          </div>
        </section>

        {/* Hero Section */}
        <section className="bg-white py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
              Ricariche telefoniche
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-3">
              Accedi rapidamente al sito ufficiale della tua compagnia.
            </p>
            <p className="text-sm text-gray-500">
              Cliccami non vende ricariche. Ti accompagna velocemente al sito ufficiale.
            </p>
          </div>
        </section>

        {/* Operators Grid Section */}
        <section className="bg-gray-50 py-12 md:py-16">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {operators?.map((operator) =>
              <div
                key={operator?.name}
                className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200 p-6 flex flex-col items-center text-center">
                
                  <div className="w-32 h-20 flex items-center justify-center mb-4">
                    <img
                    src={operator?.logo}
                    alt={operator?.alt}
                    className="max-w-full max-h-full object-contain" />
                  
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {operator?.name}
                  </h3>
                  <a
                  href={operator?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2.5 rounded-lg transition-colors duration-200 inline-block">
                  
                    Vai alla ricarica
                  </a>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Footer Section */}
        <section className="bg-white py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <p className="text-lg text-gray-700 mb-6">
              Cliccami raccoglie strumenti utili per semplificare la tua giornata.
            </p>
            <button
              onClick={() => navigate('/home-servizi')}
              className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-8 py-3 rounded-lg shadow-md transition-all duration-200 hover:shadow-lg">
              
              Torna ai servizi Cliccami
            </button>
          </div>
        </section>
      </div>
    </>);

};

export default RicaricheTelefoniche;